import { alertEventBus } from 'src/core/events/Events';
import type { AlertRequestEvent } from 'src/core/events/Events';
import Constants from 'src/core/utils/Constants';
import type { ErrorHandler } from 'src/core/utils/types/ErrorHandlerTypes';

/**
 * react-native-web ships Alert as `static alert() {}` -- an empty function. So on web every error
 * message, confirmation and success notice in this app disappeared without a trace, which is far
 * worse than an ugly dialog: a failed action looked like nothing happening at all.
 *
 * The browser's own `window.alert` was the obvious stand-in, but Chrome ignores it completely
 * inside a cross-origin iframe -- and that is how this app is embedded on topicusevents.nl/app, so
 * the gap would be back in the one view where it matters most. The notice therefore goes to
 * AlertDialog, which lives in the React tree.
 *
 * It travels as an event because this file is core, and core cannot import the domain store that
 * holds the queue; useAlertDialogStore listens on the bus and queues it.
 */
const errorHandler: ErrorHandler = (subject, message) => {
	const event: AlertRequestEvent = { title: subject, message };

	alertEventBus.emit(Constants.eventAlertOnRequest, event);
};

export default errorHandler;
